@if (isPostPayment()) {
  {{ 'shared:licenses.postPaymentMode' | i18next }}
} @else {
  {{ 'shared:licenses.prePaymentMode' | i18next }}
}
@if (isYearlyLicenseMode() || isMonthlyLicenseMode()) {
  &bull;
}
@if (isYearlyLicenseMode()) {
  {{ 'shared:licenses.annualSubscription' | i18next }}
} @else if (isMonthlyLicenseMode()) {
  {{ 'shared:licenses.monthlySubscription' | i18next }}
}
